import React from 'react';
import { useLang } from '../context/LanguageContext';
import { useContent } from '../context/ContentContext';
import { resolveImg } from '../api';
import { Camera, Instagram } from 'lucide-react';
import { socials } from '../data/mock';

const RealisationsSection = () => {
  const { t, lang } = useLang();
  const { content } = useContent();
  const items = content?.realisations || [];

  return (
    <section id="realisations" className="section-pad bg-[#FAF8F4] relative overflow-hidden border-t border-[#E8E2D5]">
      <div className="container-tight">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-7">
            <span className="eyebrow left">{t.realisations.eyebrow}</span>
            <h2 className="h-display mt-6" style={{ fontSize: 'clamp(40px, 5vw, 64px)' }}>
              {t.realisations.title}
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[15px] text-[#3A3A3A] leading-[1.8]">{t.realisations.subtitle}</p>
          </div>
        </div>

        {items.length === 0 ? (
          <div className="text-center py-20 border border-dashed border-[#1A1A1A]/15 bg-white max-w-2xl mx-auto">
            <Camera size={32} className="mx-auto text-[#957340] mb-4" />
            <p className="serif text-[20px] text-[#1A1A1A]">{t.realisations.empty}</p>
            <a href={socials.instagram} target="_blank" rel="noreferrer" className="mt-6 inline-flex items-center gap-2 link-underline">
              <Instagram size={14} /> @devil_perceur
            </a>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {items.map((r, idx) => {
              const type = lang === 'fr' ? r.typeFr : r.typeEn;
              return (
                <div key={r.id} className="image-hover relative group aspect-square bg-white border border-[#E8E2D5]">
                  {r.img && <img src={resolveImg(r.img)} alt={type || `realisation ${idx + 1}`} className="w-full h-full object-cover" />}
                  {type && (
                    <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                      <div className="text-[9px] tracking-[0.4em] uppercase text-[#D4B987]">{String(idx + 1).padStart(2, '0')}</div>
                      <div className="serif text-[16px] text-white mt-1">{type}</div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default RealisationsSection;
